import styled from "styled-components";

export const ProductDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const CredentialsData = styled.div`
  flex: column;
  width: 75%;
  img {
    height: 27rem;
  }

  @media (max-width: 425px) {
    width: 100%;
  }

  .infoZKP {
    display: flex;
    align-items: center;
    background: #01985d26;
    padding: 1rem 0.875rem;
    border-radius: 5px;
    margin-bottom: 1rem;
    gap: 0.5rem;
    width: 100%;

    .checkImg {
      height: 100%;
    }

    p {
      color: #434343;
      font-family: Inter;
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 500;
      line-height: 125%; /* 1.09375rem */
    }
  }
`;

export const InvoiceIdentityData = styled.div`
  border: 1px solid #dedede;
  border-radius: 5px;
  background: rgba(222, 222, 222, 0.25);
  margin-bottom: 1rem;
  padding-bottom: 1rem;

  h1 {
    color: #460259;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: 1.125rem;
    margin: 1rem;
    display: flex;
    justify-content: start;
  }

  p {
    color: #434343;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: 0.875rem;
    margin-left: 1rem;
    line-height: 1.75rem;
  }

  .note {
    color: #434343;
    background: rgba(242, 183, 5, 0.15);
    border-radius: 5px;
    margin-right: 1rem;
    height: 2.5rem;
    padding-left: 1rem;
    display: flex;
    align-items: center;
    margin-bottom: 0.75rem;

    @media (max-width: 425px) {
      height: max-content;
    }
  }

  img {
    height: 1.5rem;
    margin-left: 0.5rem;
  }
`;

export const PurchaseSummary = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;

  p {
    color: rgba(67, 67, 67, 0.75);
    font-size: 0.875rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  }

  hr {
    display: block;
    border: 0;
    border-top: 1.5px solid #dedede;
    margin-top: 0.75rem;
  }

  .fullPrice {
    color: #460259;
    font-size: 1.125rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-weight: 800;
    text-align: right;
    padding-top: 1rem;
  }
`;

export const PurchaseItems = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 16.5rem;

  p {
    color: rgba(67, 67, 67, 0.75);
    font-size: 0.875rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    margin-left: 1rem;
    padding-bottom: 0.5rem;
  }

  hr {
    display: block;
    border: 0;
    border-top: 1.5px solid #dedede;
    margin-top: 0.75rem;
  }

  img {
    width: 6.051rem;
    margin-left: 1rem;
  }

  .productName {
    color: #212121;
    font-size: 1.125rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
    font-style: normal;
    font-weight: 500;
    line-height: 127%; /* 1.42875rem */
  }

  .price {
    color: #460259;
    font-size: 1.125rem;
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-weight: 800;
  }
`;
